import PropTypes from "prop-types";
import { Empty, Spin } from "antd";
import AddonsCard from "./cards/AddonsCard";
import CustomPagination from "../../../components/custom-component/CustomPagination";

const RegularAddons = ({
    regularAddons,
    initialFetching,
    handleModalState,
    handleDeleteAddon,
    pagination,
    setPagination,
}) => {
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, currentPage: page }));
    };

    const handlePageSizeChange = (size) => {
        setPagination((prev) => ({ ...prev, pageSize: size, currentPage: 1 }));
    };

    return (
        <div className="min-w-0">
            <div className="min-w-0">
                {initialFetching ? (
                    <div className="flex justify-center items-center py-16">
                        <Spin />
                    </div>
                ) : regularAddons?.length > 0 ? (
                    <div className="grid grid-cols-1 gap-3 auto-rows-max sm:grid-cols-2 sm:gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                        {regularAddons?.map((addon) => (
                            <div key={addon?.id} className="min-w-0">
                                <AddonsCard
                                    addon={addon}
                                    setModalIsOpen={handleModalState}
                                    handleDeleteAddon={handleDeleteAddon}
                                    handleModalState={handleModalState}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex items-center justify-center py-12">
                        <Empty />
                    </div>
                )}
                <div className="mt-4 flex min-w-0 w-full justify-end lg:hidden">
                    <CustomPagination
                        variant="spaced"
                        totalItem={pagination.total}
                        pageSize={pagination.pageSize}
                        setPageSize={handlePageSizeChange}
                        currentPage={pagination.currentPage}
                        setCurrentPage={handlePageChange}
                        pageSizeOptions={[10, 20, 50, 100]}
                        showSizeChanger
                    />
                </div>
                <div className="mt-4 hidden min-w-0 w-full justify-end lg:flex">
                    <CustomPagination
                        variant="default"
                        totalItem={pagination.total}
                        pageSize={pagination.pageSize}
                        setPageSize={handlePageSizeChange}
                        currentPage={pagination.currentPage}
                        setCurrentPage={handlePageChange}
                        pageSizeOptions={[10, 20, 50, 100]}
                        showSizeChanger
                    />
                </div>
            </div>
        </div>
    );
};

RegularAddons.propTypes = {
    regularAddons: PropTypes.array.isRequired,
    initialFetching: PropTypes.bool.isRequired,
    handleModalState: PropTypes.func.isRequired,
    handleDeleteAddon: PropTypes.func.isRequired,
    pagination: PropTypes.shape({
        currentPage: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
    }).isRequired,
    setPagination: PropTypes.func.isRequired,
};

export default RegularAddons;
